import { render, staticRenderFns } from "./Flows.vue?vue&type=template&id=441d0731&"
import script from "./Flows.vue?vue&type=script&lang=js&"
export * from "./Flows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports